var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#3474B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.083 15.0598L12.9226 10.0726C12.7851 9.98858 12.6278 9.94266 12.4667 9.93962C12.3056 9.93657 12.1466 9.97649 12.0061 10.0553C11.8655 10.1341 11.7485 10.2489 11.6671 10.3879C11.5856 10.5269 11.5427 10.6851 11.5427 10.8463V20.8214C11.5429 20.9825 11.5859 21.1406 11.6673 21.2796C11.7488 21.4185 11.8658 21.5333 12.0063 21.612C12.1468 21.6908 12.3057 21.7307 12.4667 21.7277C12.6278 21.7248 12.7851 21.679 12.9226 21.5951L21.083 16.6079C21.2156 16.5268 21.3251 16.4131 21.4011 16.2776C21.4771 16.142 21.517 15.9892 21.517 15.8338C21.517 15.6785 21.4771 15.5257 21.4011 15.3901C21.3251 15.2546 21.2156 15.1408 21.083 15.0598V15.0598Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a5b08c92.svg";
export { ForwardRef as ReactComponent };